// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__26Mdj","content":"styles_content__2cVMN","row":"styles_row__3WHCv","footer":"styles_footer__2TPAr","phraseLength":"styles_phraseLength__krsBh"};